export default __webpack_public_path__ + "static/media/star.bc67a869.svg";